import React, { Component } from 'react';
import { Tabs, Tab, CircularProgress, IconButton, Menu, withStyles, MenuProps } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ErrorIcon from '@material-ui/icons/Error';
import { OrderDetailInfo } from '../components/order-detail-list.component';
import '../resources/css/order-detial.scss';
// API
import { DefaultRequest } from '../requests/default.request';
// import Store from '../redux/store';
// import { SettingInfo } from '../entities/setting-info.entity';
// Message Modal
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from "../messenger/module";
import { CourseGroup, HistoryDish } from '../constants/type.constant';
import _ from 'lodash';
import i18n from '../i18n';
import { getCacheField } from '../tools/get-cache-field';
import { getSettingInfo } from '../tools/get-setting-info';
import ShoppingCart from '../modules/shopping-cart';
import AutoSizer from 'react-virtualized-auto-sizer';
import List from 'react-virtualized/dist/commonjs/List';
import { v4 as uuidv4 } from 'uuid';
import { StateManager } from '../redux/stateManager';
import { InfiniteLoader } from 'react-virtualized';
import untreatedPic from '../assets/dish-dispensing-status/untreated.png';
import servingPic from '../assets/dish-dispensing-status/serving.png';
import accomplishPic from '../assets/dish-dispensing-status/accomplish.png';
import unablemakePic from '../assets/dish-dispensing-status/unablemake.png';
import stopmakingPic from '../assets/dish-dispensing-status/stopmaking.png';

let OrderHistoryListHeight: number = window.innerHeight - 140;

class OrderHistory extends Component<Props, State> {

    public messengerModule: MessengerModule;
    public InfiniteLoaderKey: string = '';
    public AutoSizerRef: List | null = null;
    public scrollLock: boolean = false;
    public listHeight: number[] = [];
    public turnTabsRef: any = React.createRef<HTMLDivElement>();
    public _timeoutIdMap: any = {};
    // 菜名显示
    public showMenuItemType: boolean = _.get(getSettingInfo('show-item-name1-or-item-name2', 'value'), 'showItemName1', true);
    // 已下单菜品状态显示
    public dishStatusType: number = getSettingInfo('order_menu_status', 'value') || 0;
    // 货币符号
    public currency_name: string = '€';

    // 菜品状态（Null/0:未制作，1:已制作，2:已上菜，3:暂停制作，5:不可制作，新增：11:已备菜）
    imgPath = [
        {
            url: untreatedPic,
            name: i18n.t('order_history_page_text_no_make')
        },
        {
            url: servingPic,
            name: i18n.t('order_history_page_text_make_complete')
        },
        {
            url: accomplishPic,
            name: i18n.t('order_history_page_text_service_complete')
        },
        {
            url: unablemakePic,
            name: i18n.t('order_history_page_text_unable_make')
        },
        {
            url: stopmakingPic,
            name: i18n.t('order_history_page_text_pause_make')
        },
    ];

    constructor(props: Props) {
        super(props);
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
        this._rowRenderer = this._rowRenderer.bind(this);
        this._onScroll = this._onScroll.bind(this);
        this._isRowLoaded = this._isRowLoaded.bind(this);
        this._loadMoreRows = this._loadMoreRows.bind(this);

        this.state = {
            tabValue: 'All',
            // 轮次下标
            selectedRoundIndex: 0,
            // 订单详情
            // orders: {} as OrderInfo,
            ordersDishesHistory: {
                all: {},
                customer: {},
            },
            // 	当前的订单列表
            roundlist: [],
            // 所有订单列表
            allRoundlist: [],
            // 轮次排序
            roundTurnTabs: [],
            // sortTurnkeys: [],
            // 额外菜品
            extraDishes: [],
            // 服务员菜品
            waiterDishes: [],
            // 每轮的统计金额
            roundTotal: 0,
            // 选择当前查看角色
            ordersRoles: 'customer',
            // 模式选择显示
            isShowMode: false,
            selectRoles: [
                { name: 'customer', type: 'customer', locales: 'order_history_page_text_customer' },
                { name: 'waiter', type: '0', locales: 'order_history_page_text_waiter' },
                { name: 'extra', type: 'extra', locales: 'order_history_page_text_extra' },
                { name: 'null', type: 'null', locales: 'order_history_page_text_order_devices' },
            ],
            // 记录点餐数
            quantity: 0,
            // 每个订单模式的全选记录key值
            roundKey: 'customerAll',
            menuId: getSettingInfo('package-fee', 'value').menu_id ?? 9,
            // 订单总金额
            totalPrice: 0,
            // 虚拟列表
            loadedRowsMap: {},
            loading: false,
            // anchorEl: null,
            comboDishGroup: {},
            isOpenNoticeMenus: false,
        }
        this.currency_name = StateManager.getFromCache('currency_name') || '€';

    };

    // *********************
    // 生命周期
    // *********************
    public async UNSAFE_componentWillMount() {
        this.InfiniteLoaderKey = uuidv4();
    }
    public async componentDidMount() {
        // we check if already has a account
        // this.setState({ loading: true });
        await this.getOrders()
        // this.setState({ loading: false });
    }

    public async componentWillUnmount() {
        // $ alwyas unsubscribe in un mount function
        this.setState = (state, callback) => { return; };
    }

    // *********************
    // 方法区
    // *********************

    /**
     * 获取订单详情
     */
    public getOrders = async () => {
        try {
            this.setState({ loading: true });
            const { menuId } = this.state;
            const ORDERS = await DefaultRequest.getOrderDetail(getCacheField('orderTab.orderId'), menuId)
            const ORDERSHISTORY = await DefaultRequest.getHistoryDish(getCacheField('orderTab.orderId'), menuId, 'type,additional')
            let comboDishGroup: Record<string, CourseGroup[]> = {};
            // 处理顾客轮次
            const customerRoundTitles = Object.keys(ORDERS.dishes_history.customer)
                .map(n => {
                    return { totalNum: 0, key: n, typeLabel: i18n.t('history_order_you'), round: Number(n), isTitle: true, sortVal: Number(n) }
                })
                .sort((a, b) => b.sortVal - a.sortVal)
            const _tabValue = customerRoundTitles?.[0]?.key || 'waiter';
            let roundListDetail: any = [
                ...customerRoundTitles,
                { totalNum: 0, key: 'waiter', round: 0, typeLabel: i18n.t('order_history_page_text_waiter'), isTitle: true, sortVal: -1 },
                { totalNum: 0, key: 'additionalCharges', typeLabel: i18n.t('order_history_page_text_extra'), round: 0, isTitle: true, sortVal: -2 },
                { totalNum: 0, key: 'other', round: 0, typeLabel: i18n.t('order_history_page_text_order_devices'), isTitle: true, sortVal: -3 },
            ];
            const allRoundDishes = _.get(ORDERSHISTORY, ['type_round_dish', 'customer', 'all']) || [];
            comboDishGroup = allRoundDishes.reduce((pre: any, cur: any) => {
                if (cur.item_type === 3) {
                    pre[`${cur.menu_item_id}#${cur.order_detail_id}`] = cur.course_group || [];
                }
                return pre;
            }, {});
            for (const key in ORDERSHISTORY) {
                if (key === 'additionalCharges') {
                    let fIndex = roundListDetail.findIndex((i: any) => i?.key === 'additionalCharges');
                    const extraDishes = _.get(ORDERSHISTORY.additionalCharges, 'total')?.map(item => Object.assign(item, { disabled: true }));
                    if (fIndex > -1 && extraDishes.length > 0) {
                        roundListDetail.splice(fIndex, 1, [
                            { totalNum: this.getDishesLen(extraDishes), key: 'additionalCharges', typeLabel: i18n.t('order_history_page_text_extra'), round: 0, isTitle: true, sortVal: -2 },
                            ...extraDishes
                        ])
                    }
                }
                if (key === 'type_round_dish') {
                    const allRoundDishes = _.get(ORDERS, 'dishes_history');
                    for (const rdKey in allRoundDishes) {
                        // if (rdKey === 'all' || rdKey === 'customer') continue;
                        // const isNumberKey: boolean = Number(rdKey) >= 0;
                        // if (isNumberKey || rdKey === 'waiter') {
                        //     let rdfIndex = roundListDetail.findIndex((i: any) => i?.key === rdKey);
                        //     const turnDishes = _.get(allRoundDishes, rdKey);
                        //     if (rdfIndex > -1 && turnDishes.length > 0) {
                        //         roundListDetail.splice(rdfIndex, 1, [
                        //             { totalNum: turnDishes.length, key: rdKey, typeLabel: rdKey === 'waiter' ? i18n.t('order_history_page_text_waiter') : i18n.t('您'), round: Number(rdKey), isTitle: true, sortVal: Number(rdKey) },
                        //             ...turnDishes
                        //         ])
                        //     }
                        // }
                        // else {
                        //     let otherKeyIndex = roundListDetail.findIndex((i: any) => i?.key === 'other');
                        //     const turnDishes = _.get(allRoundDishes, rdKey);
                        //     if (otherKeyIndex > -1 && turnDishes.length > 0) {
                        //         roundListDetail.splice(otherKeyIndex, 1, [
                        //             { totalNum: turnDishes.length, key: rdKey, typeLabel: i18n.t('order_history_page_text_order_devices'), round: Number(rdKey), isTitle: true, sortVal: Number(rdKey) },
                        //             ...turnDishes
                        //         ])
                        //     }
                        // }
                        if (rdKey === 'customer') {
                            const customerDishes = allRoundDishes[rdKey];
                            for (const cusKey in customerDishes) {
                                let rdfIndex = roundListDetail.findIndex((i: any) => i?.key === cusKey);
                                const turnDishes = _.get(customerDishes, cusKey);
                                if (rdfIndex > -1 && turnDishes.length > 0) {
                                    roundListDetail.splice(rdfIndex, 1, [
                                        { totalNum: this.getDishesLen(turnDishes), key: cusKey, typeLabel: i18n.t('history_order_you'), round: Number(cusKey), isTitle: true, sortVal: Number(cusKey) },
                                        ...turnDishes
                                    ])
                                }
                            }
                        }
                        else if (rdKey === 'waiter') {
                            const waiterDishes = allRoundDishes[rdKey];
                            let rdfIndex = roundListDetail.findIndex((i: any) => i?.key === rdKey);
                            for (const waiKey in waiterDishes) {
                                const turnDishes = _.get(waiterDishes, waiKey)?.map(item => Object.assign(item, { disabled: true }));
                                if (rdfIndex > -1 && turnDishes.length > 0) {
                                    roundListDetail.splice(rdfIndex, 1, [
                                        { totalNum: this.getDishesLen(turnDishes), key: rdKey, typeLabel: i18n.t('order_history_page_text_waiter'), round: 0, isTitle: true, sortVal: -1 },
                                        ...turnDishes
                                    ])
                                }
                            }
                        }
                        else {
                            let otherKeyIndex = roundListDetail.findIndex((i: any) => i?.key === 'other');
                            const turnDishes = _.get(allRoundDishes, rdKey);
                            if (otherKeyIndex > -1 && turnDishes.length > 0) {
                                roundListDetail.splice(otherKeyIndex, 1, [
                                    { totalNum: this.getDishesLen(turnDishes), key: rdKey, typeLabel: i18n.t('order_history_page_text_order_devices'), round: 0, isTitle: true, sortVal: -3 },
                                    ...turnDishes
                                ])
                            }
                        }
                    }
                }
            }
            roundListDetail = _.flatten(roundListDetail);
            const _roundTurnTabs = this.setCustomerTurns({ roundlist: roundListDetail });
            this.setState({
                totalPrice: ORDERS.should_amount ?? 0,
                roundTurnTabs: _roundTurnTabs,
                tabValue: _tabValue,
                roundlist: roundListDetail,
                ordersDishesHistory: ORDERSHISTORY.type_round_dish,
                extraDishes: ORDERSHISTORY.additionalCharges.total,
                comboDishGroup,
                loading: false,
            }, () => {
                this.getHeightList();
            })
        } catch (error) {
            console.log(error);
            this.setState({ loading: false });
        }
    }

    getDishesLen = (data: any[]) => data.reduce((pre, cur) => pre + (cur.quantity ?? 0), 0);

    /**
     * 处理顾客轮次
     * @returns
     */
    setCustomerTurns({
        roundlist
    }: { roundlist: any }) {
        let roundTurnTabs: RoundTurnTab[] = [];

        roundlist.forEach((item: any, index: number) => {
            if (item.isTitle) {
                roundTurnTabs.push({
                    key: item.key,
                    tabLabel: item.round > 0 ? item.round : item.typeLabel,
                    rowIndex: index,
                })
            }
        })

        return roundTurnTabs;
    }

    /**
     * 
     */
    _onScrollToRowChange(value: number) {
        let winHeight = OrderHistoryListHeight || 0;
        const listHeightLen = this.listHeight.length;
        let acHeight = this.listHeight[value || 0];
        if ((this.listHeight[listHeightLen - 1] - this.listHeight[value]) <= winHeight) {
            acHeight = this.listHeight[listHeightLen - 1] - winHeight;
        }
        this.scrollLock = true;
        this.AutoSizerRef?.recomputeGridSize({ rowIndex: value });
        this.AutoSizerRef?.scrollToPosition(acHeight);
        setTimeout(() => {
            this.scrollLock = false;
            this.setState({
                selectedRoundIndex: value,
            })
        }, 200);
    }

    /**
     * 列表滚动时触发
     */
    _onScroll(position: { clientHeight: number, scrollHeight: number, scrollTop: number }) {
        if (!this.scrollLock) {
            this.changeTabsValue(Math.abs(Math.round(position.scrollTop)));
        }
    }

    _isRowLoaded({ index }: any) {
        const loadedRowsMap = this.state.loadedRowsMap || {};
        return !!loadedRowsMap?.[index];
    }

    _loadMoreRows({ startIndex, stopIndex }: any) {
        const loadedRowsMap = this.state.loadedRowsMap || {};

        for (var i = startIndex; i <= stopIndex; i++) {
            loadedRowsMap[i] = 1;
        }

        const timeoutId: any = setTimeout(() => {

            delete this._timeoutIdMap[timeoutId];

            for (var i = startIndex; i <= stopIndex; i++) {
                loadedRowsMap[i] = 2;
            }
            this.setState({ loadedRowsMap })

            promiseResolver();
        }, 2000);
        this._timeoutIdMap[timeoutId] = true;

        let promiseResolver: any;
        return new Promise(resolve => {
            promiseResolver = resolve;
        });
    }

    /**
     * 改变选中tabs
     * - scrollY
     */
    changeTabsValue(scrollY: number) {
        try {
            let scrollIndex: number;
            const { listHeight } = this;
            scrollIndex = _.sortedIndex(listHeight, scrollY) - 1;
            scrollIndex = scrollIndex < 0 ? 0 : scrollIndex;
            this.changeTabsValueIndex(scrollIndex);
        } catch (error) { }
    }
    /**
     * 改变选中tabs
     * - scrollIndex
     */
    changeTabsValueIndex(scrollIndex: number, isSetIndex: boolean = true) {
        const wrapper: Element | null = document.querySelector('#roundTabsListID');
        const contentList = wrapper?.getElementsByClassName('turn-tab');
        try {
            if (contentList) {
                for (let i = 0; i < contentList.length; i++) {
                    if (scrollIndex === i) {
                        contentList[i].classList.add('active-turn-tab')
                    }
                    else {
                        contentList[i].classList.remove('active-turn-tab')
                    }
                }
                // scrollToElement 需要HTMLElement，这里获取到的是Element数组
                const el = contentList[scrollIndex];
                if (el) {
                    setTimeout(() => {
                        el?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'center' })
                    }, 200)
                }
                if (isSetIndex && scrollIndex !== this.state.selectedRoundIndex) {
                    this.setState({ selectedRoundIndex: scrollIndex })
                }
            }
        } catch (error) { }
    }

    onWheelToScroll = (e: React.WheelEvent<HTMLDivElement>) => {
        const el = this.turnTabsRef?.current;
        if (el) {
            el.scrollTo({
                left: el.scrollLeft + e.deltaY * 5,
                behavior: 'smooth'
            });
        }
        e.preventDefault();
    }

    /**
     * 获取菜品分类title的高度,并初始化滚动插件
     */
    getHeightList() {
        let newlistHeight: Array<number> = [];
        let height = -48;
        const roundListLen = this.state.roundlist.length;
        this.state.roundlist.forEach((item: any, index: number) => {
            let itemHeight = 102.2;
            if (item.isTitle) {
                itemHeight = 48;
            }
            else {
                if (item.condiments?.length > 0 || item.description?.length > 0) {
                    itemHeight += 19.6;
                }
                if (item?.excess_price_and_condiments_price_for_view?.trim()) {
                    itemHeight += 18.4;
                }
                // 套餐
                if (item?.item_type === 3) {
                    const courseGroup = this.getComboGroup(item);
                    const setMealDishesTotal = this.renderSetMenuDetail(courseGroup).length;
                    const num = Math.round(setMealDishesTotal);
                    height += num * 25 + 20;
                }
            }
            height += itemHeight;
            if (item.isTitle || roundListLen === index + 1) {
                newlistHeight.length === 0 ?
                    newlistHeight.push(0)
                    :
                    newlistHeight.push((roundListLen === index + 1) ? height + 48 : height);
            }
        })
        this.listHeight = newlistHeight;
        // 滚动最顶
        this._onScrollToRowChange(0);
    }

    /**
     * 轮次切换
     * 设置 当前的轮次下标和订单列表
     */
    public onRoundSelect(eachRoundIndex: number | string) {
        const { ordersDishesHistory, ordersRoles } = this.state;
        let roundListDetail = [];
        let totalPrice: string = '0';
        let quantity = 0;
        this.setState({
            selectedRoundIndex: eachRoundIndex,
        });

        switch (eachRoundIndex) {
            case 'customerAll':
                // 默认显示所有数据
                roundListDetail = this.mergeOrderDetail(ordersRoles);
                break;
            case 'waiterAll':
                // 默认显示所有数据
                roundListDetail = this.state.waiterDishes;
                break;
            case 'extraDishes':
                roundListDetail = this.state.extraDishes;
                break;
            case 'null':
                roundListDetail = this.mergeOrderDetail(ordersRoles);
                break;
            default:
                // 当前轮次数据
                let roundDishes = _.get(ordersDishesHistory, `${ordersRoles}.${eachRoundIndex}`, []);
                // 自助开台模式，历史记录根据customer区分显示
                if (ShoppingCart.GLOBAL_SELF_ORDER_RULE) {
                    roundDishes = _.filter(roundDishes, (item) => {
                        return item.customer_name === getCacheField('orderTab.customer')
                    })
                }
                roundListDetail = roundDishes;
                break;
        }

        // 计算出每轮的合计总量
        for (let item of (roundListDetail || [])) {
            totalPrice = (parseFloat(totalPrice) + item.product_price * item.quantity).toFixed(2);
            quantity += item.quantity;
        }

        // 更新
        this.setState({
            roundTotal: totalPrice,
            roundlist: roundListDetail,
            quantity,
        }, () => {
            this.AutoSizerRef?.scrollToPosition(0);
            this.AutoSizerRef?.recomputeGridSize();
        });
    }

    /**
     * 切换订单详情信息
     * @param index  下标
     */
    public switchRoles(index: number, type: string) {
        // let totalPrice = '0';
        // let roundIndex = '', roundKey = '';
        // let roundlist = [];
        // let sortTurnkeys: string[] = [];
        // const { ordersDishesHistory } = this.state;
        // switch (index) {
        //     case 0:
        //         roundIndex = 'customerAll';
        //         roundKey = 'customerAll';
        //         sortTurnkeys = _.get(ordersDishesHistory, `customer`) ? Object.keys(ordersDishesHistory.customer) : [];
        //         roundlist = this.mergeOrderDetail(type);
        //         break;
        //     case 1:
        //         roundIndex = 'waiterAll';
        //         roundKey = 'waiterAll';
        //         sortTurnkeys = ['0']
        //         roundlist = this.state.waiterDishes
        //         break;

        //     case 2:
        //         roundIndex = 'extraDishes';
        //         roundKey = 'extraDishes';
        //         sortTurnkeys = ['extraDishes'];
        //         roundlist = this.state.extraDishes;
        //         break;
        //     case 3:
        //         roundIndex = 'null';
        //         roundKey = 'null';
        //         sortTurnkeys = ['null'];
        //         roundlist = this.mergeOrderDetail(type);
        //         break;
        //     default:
        //         sortTurnkeys = [];
        //         break;
        // }

        // // 统计Total
        // for (let item of (this.state.roundlist || [])) {
        //     totalPrice = (parseFloat(totalPrice) + item.product_price * item.quantity).toFixed(2);
        // }
        // this.state.roundlist?.forEach((item: any) => {
        //     item.isSelected = false;
        // });

        // this.setState({
        //     selectedRoundIndex: roundIndex,
        //     roundTotal: totalPrice,
        //     ordersRoles: type,
        //     sortTurnkeys,
        //     roundlist,
        //     roundKey,
        //     isShowMode: false,
        //     tabValue: 'All'
        // }, () => {
        //     this.AutoSizerRef?.scrollToPosition(0);
        // })
    }

    /**
      * 所有订单详情的合并
      */
    public mergeOrderDetail(rules: string) {
        let roundListDetail: any[] = [];
        const ordersDishesHistory = _.get(this.state.ordersDishesHistory, `${rules}.all`);

        ordersDishesHistory && Object.values(ordersDishesHistory).forEach((v: any) => {
            roundListDetail = roundListDetail.concat(v);
        });
        return roundListDetail;
    }

    public handleChange = (event: any, newValue: any) => {
        this.setState({
            tabValue: newValue
        }, () => {
            if (newValue === 'All') {
                this.onRoundSelect(this.state.roundKey);
            } else {
                this.onRoundSelect(newValue);
            }
        })
    };

    _rowRenderer({ index, key, style }: any) {
        let item: any = this.state.roundlist[index];
        return (
            <div key={key} style={style} >
                {
                    item.isTitle ?
                        <div className='round-type-label-area'>
                            <div className={`label-line ${this.state.roundTurnTabs[this.state.selectedRoundIndex as any].rowIndex === index ? 'active-label-line' : ''}`}>
                                <span className='m-horizon'>
                                    {item.typeLabel}
                                </span>
                                <span>{'|'}</span>
                                {
                                    item.round ?
                                        <span className='m-horizon'>
                                            {/* {`第${item.round}轮`} */}
                                            {i18n.t('history_order_round', { round: item.round })}
                                        </span>
                                        :
                                        null
                                }
                                <span className={`${item.round ? '' : 'm-horizon'}`}>
                                    {/* {`共${item.totalNum}道菜`} */}
                                    {i18n.t('history_order_total', { number: item.totalNum })}
                                </span>
                            </div>
                        </div>
                        :
                        <OrderDetailInfo
                            key={index}
                            item={item}
                            isInterfaceSwitch={!!this.props.isInterfaceSwitch}
                            menuItemType={this.showMenuItemType}
                            dishStatusType={this.dishStatusType}
                            comboDishGroup={this.state.comboDishGroup}
                            isShowHistoryAppendBtn={true}
                        />
                }
            </div>)
    }

    /**
     * 整理套餐组内的菜品
     * - 获取数量大于0的
     */
    renderSetMenuDetail(setMealGroups: CourseGroup[] | undefined) {
        let setMealDishes = _.flatMap((setMealGroups || [])?.map((groupItem) => {
            return (groupItem?.course_detail || []).filter((dishItem) => (dishItem.quantity && dishItem.quantity > 0))
        }))
        return setMealDishes;
    }

    onHandleCusMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        // this.setState({
        //     anchorEl: event.currentTarget
        // })
        this.setState({
            isOpenNoticeMenus: !this.state.isOpenNoticeMenus
        })
    };

    // onHandleCusMenuClose = () => {
    //     this.setState({
    //         anchorEl: null
    //     })
    // };

    public getComboGroup = (item: any) => {
        return this.state.comboDishGroup?.[`${item.item_id}#${item.order_detail_id}`] || [];
    }

    // *********************
    // 视图区
    // *********************

    render() {
        const { roundlist, loading, roundTurnTabs, tabValue } = this.state;

        return (
            <div className='main order-history-page'>
                <div className={loading ? 'loading' : 'hide'}>
                    <CircularProgress color='primary' />
                </div>
                <div className='roundlist'>
                    <div
                        id='roundTabsListID'
                        ref={this.turnTabsRef}
                        className='roundSwitch'
                        onWheel={this.onWheelToScroll}
                    >
                        {/* <Tabs
                            style={{ flex: 1 }}
                            textColor='primary'
                            indicatorColor='primary'
                            value={tabValue}
                        onChange={this.handleChange}
                        > */}
                        {/* <Tab
                                // onClick={() => { this.onRoundSelect(this.state.roundKey) }}
                                style={{ minWidth: 30, marginRight: 5 }}
                                label={'All'}
                                value={'All'}
                            /> */}
                        {
                            roundTurnTabs.map((item: RoundTurnTab, index) => {
                                // let itemKey = '';
                                // switch (item) {
                                //     case '0':
                                //         itemKey = `waiter`;
                                //         break;
                                //     case 'null':
                                //         itemKey = `null`;
                                //         break;
                                //     case 'extraDishes':
                                //         break;
                                //     default:
                                //         itemKey = item;
                                //         break;
                                // }
                                // 过滤Tab选项不显示
                                // if (itemKey !== 'all' && itemKey !== 'waiter' && itemKey !== 'null') {
                                return (
                                    <Tab
                                        key={index}
                                        className={`turn-tab ${item.key === tabValue ? 'active-turn-tab' : ''}`}
                                        value={item.key}
                                        label={item.tabLabel}
                                        onClick={() => {
                                            this.scrollLock = false;
                                            this.changeTabsValueIndex(index, false);
                                            this._onScrollToRowChange(index);
                                        }}
                                    >
                                    </Tab>
                                )
                                // }
                                // return null
                            })
                        }
                        {/* </Tabs> */}
                    </div>
                    <div className='switchRolesId' style={{ display: 'none' }}>
                        <div className='switchRoles'>
                            <Button
                                style={{ minWidth: 100, backgroundColor: '#212b45', color: '#7d8bb2' }}
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                variant="contained"
                                onClick={() => {
                                    this.setState({ isShowMode: !this.state.isShowMode })
                                }}
                                endIcon={
                                    this.state.isShowMode ?
                                        <ArrowDropDownIcon style={{ fontSize: 16, color: '#5B73B2' }} /> :
                                        <ArrowDropUpIcon style={{ fontSize: 16, color: '#5B73B2' }} />}
                            >
                                {
                                    (() => {
                                        switch (this.state.ordersRoles) {
                                            case 'waiter':
                                                return `${i18n.t('order_history_page_text_waiter')}`;
                                            case 'extra':
                                                return `${i18n.t('order_history_page_text_extra')}`;
                                            case 'null':
                                                return `${i18n.t('order_history_page_text_order_devices')}`;
                                            default:
                                                return `${i18n.t('order_history_page_text_customer')}`;
                                        }
                                    })()
                                }
                            </Button>
                            <div style={{ position: 'absolute', width: '100%', backgroundColor: '#212b45' }}>
                                {
                                    this.state.isShowMode &&
                                    this.state.selectRoles.map((val, index) => {
                                        return (
                                            <MenuItem
                                                style={{ color: this.state.ordersRoles === val.name ? '#C1D2FD' : '#909ab3' }}
                                                key={index}
                                                onClick={() => this.switchRoles(index, val.name)}>
                                                {i18n.t(val.locales)}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        {/* {
                            customer.length > 0 && (
                                <div className="idRight">
                                    {customer}
                                </div>
                            )} */}
                    </div>
                </div>
                {/* orderList */}
                <div style={{ flex: 1 }}>
                    <InfiniteLoader
                        key={this.InfiniteLoaderKey}
                        isRowLoaded={this._isRowLoaded}
                        loadMoreRows={this._loadMoreRows}
                        rowCount={roundlist.length}
                    >
                        {({ onRowsRendered, registerChild }) => (
                            <AutoSizer disableHeight >
                                {({ width }) => (
                                    <List
                                        containerStyle={{ pointerEvents: 'auto' }}
                                        ref={refs => { this.AutoSizerRef = refs }}
                                        // ref={registerChild}
                                        onRowsRendered={onRowsRendered}
                                        onScroll={this._onScroll}
                                        height={OrderHistoryListHeight}
                                        overscanRowCount={1}
                                        rowCount={roundlist?.length || 0}
                                        rowHeight={
                                            ({ index }) => {
                                                let item = roundlist?.[index] as any;
                                                let height = 102.2;
                                                if (item.isTitle) {
                                                    height = 48;
                                                }
                                                else {
                                                    if (item.condiments?.length > 0 || item.description?.length > 0) {
                                                        height += 19.6;
                                                    }
                                                    if (item?.excess_price_and_condiments_price_for_view?.trim()) {
                                                        height += 18.4;
                                                    }
                                                    // 套餐
                                                    if (item?.item_type === 3) {
                                                        const courseGroup = this.getComboGroup(item);
                                                        const setMealDishesTotal = this.renderSetMenuDetail(courseGroup).length;
                                                        const num = Math.round(setMealDishesTotal);
                                                        height += num * 25 + 20;
                                                    }
                                                }
                                                return Number(height.toFixed(2));
                                            }
                                        }
                                        rowRenderer={this._rowRenderer}
                                        width={width}
                                    />
                                )}
                            </AutoSizer>
                        )}
                    </InfiniteLoader>
                </div>
                {/* bottom Total */}
                <div className='bottomTotal'>
                    <div className='totalText'>{i18n.t('order_cart_page_text_total')}</div>
                    <div >{this.state.totalPrice.toFixed(2)} {this.currency_name}<span className='totalText-style'>一</span></div>
                    <IconButton
                        className='bottom-notice-icon'
                        onClick={this.onHandleCusMenuClick}
                    >
                        <ErrorIcon />
                    </IconButton>
                    {/* <StyledMenu
                        id="customized-menu"
                        anchorEl={this.state.anchorEl}
                        keepMounted
                        open={Boolean(this.state.anchorEl)}
                        onClose={this.onHandleCusMenuClose}
                    > */}
                    <div className='notice-menu-box' style={{ opacity: this.state.isOpenNoticeMenus ? 1 : 0 }}>
                        {
                            this.imgPath.map((item, index) => {
                                return (
                                    <StyledMenuItem key={index} className="order-history-customize-menu-item">
                                        <img className='img-icon' src={item.url} alt="" />
                                        <span className='img-icon-label'>{item.name}</span>
                                    </StyledMenuItem>
                                )
                            })
                        }
                    </div>
                    {/* </StyledMenu> */}
                </div>
            </div >
        );
    }

}

export default withSnackbar(OrderHistory);

const StyledMenu = withStyles({
    paper: {
        background: '#323E5F',
        borderRadius: 10,
    },
})((props: MenuProps) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        {...props}
    />
));

const StyledMenuItem = withStyles((theme: any) => ({
    root: {
        color: '#CBD2E3',
        fontSize: 14,
        '&:focus': {
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
            },
        },
    },
}))(MenuItem);

// *********************
// Types
// *********************

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    item: any;
}

type RoundTypeLabel = {
    key: string;
    isTitle: boolean;
    round: number;
    typeLabel: string;
    totalNum: number;
    sortVal: number;
}

type RoundTurnTab = {
    key: string;
    tabLabel: string;
    rowIndex: number;
}

type State = {
    tabValue: string | number
    roundlist: Array<HistoryDish | RoundTypeLabel>
    allRoundlist: Array<HistoryDish>
    ordersDishesHistory: {
        all: {
            [round_name: string]: Array<HistoryDish>
        },
        customer: {
            [round_name: number]: Array<HistoryDish>
        }
    }
    roundTurnTabs: Array<RoundTurnTab>;
    // sortTurnkeys: string[]
    selectedRoundIndex: number | string
    extraDishes: Array<HistoryDish>
    waiterDishes: Array<HistoryDish>
    roundTotal: number | string
    ordersRoles: string
    isShowMode: boolean
    selectRoles: Array<{
        [key: string]: string
    }>
    quantity: number
    roundKey: string
    menuId: number
    totalPrice: number;
    loadedRowsMap: any
    loading: boolean;
    // anchorEl: any;
    comboDishGroup: Record<string, any>;
    isOpenNoticeMenus: boolean;
}

type Props = {
    isInterfaceSwitch?: boolean;
} & WithSnackbarProps
